import {Frontend} from "./frontend";

(function () {
    XonBoard.Vendors = {
        list: {
            selectors: {
                vendors_table: $('#vendors-table'),
                count_label: $('#count-label'),
            },

            init: function () {
                let self = this;
                let table = this.selectors.vendors_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.vendors_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsFiltered);
                            return json.data;
                        }
                    },
                    columns: [
                        {
                            data: 'name',
                            name: 'vendors.name',
                            render: (name, type, vendor) => `<span class="name-with-logo">${vendor.logo || '<span class="name-with-logo__placeholder"><i class="fa fa-briefcase" aria-hidden="true"></i></span>'}<span>${name}</span></span>`
                        },
                        {data: 'email', name: 'vendors.email'},
                        {data: 'phone_number', name: 'vendors.phone_number'},
                        {data: 'mobile_number', name: 'vendors.mobile_number'},
                        {data: 'actions', name: 'actions', searchable: false, sortable: false}
                    ],
                    order: [[0, "asc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                         Frontend.Utils.dtAnchorToForm(row);
                    }
                });
                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);

            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },

        },

        edit: {
            selectors: {},

            init: function (locale) {
                this.addHandlers(locale);
                XonBoard.tinyMCE.init(locale);
            },

            addHandlers: function (locale) {
            },
        },
    }
})();
